module.exports = __webpack_public_path__ + "img/bg_3@2x.96dcb5db.png";